import React, { lazy, Suspense } from 'react';
import MotionPage from './MotionPage';

export default function asyncComponent(importFunc) {
  const LazyComponent = lazy(importFunc);

  return function WrappedLazyComponent(props) {
    return (
      <Suspense fallback={null}>
        <MotionPage>
          <LazyComponent {...props} />
        </MotionPage>
      </Suspense>
    );
  };
}
